import type { Nullable } from '@shared/models/types/primary'

export const getFirstArrayItem = <T>(array?: Nullable<Array<T>>) => {
  if (array && array.length) {
    return (array[0] as T) || null
  }
  return null
}
